import {FC, useEffect, useState} from "react";
import {
  IInitiativeDescription,
  IRegulation,
} from "../../../pages/StateInitiative/StateInitiative.type";

import IconUrlWorld from "../../../assets/icons/world_src.svg";
import ImgMock from "../../../assets/images/mock-description-initiative.jpg";
import {getDomainFromUrl} from "../../../helper/functions";
import {LoaderSkeleton} from "../styles";
import Markdown from "react-markdown";
import {RichTextParser, richTextToPlainText} from "../../../utils/RichTextParser";

interface IProps {
  text?: string | IInitiativeDescription[] | IRegulation[] | any[];
  image?: string;
  type?: "description" | "trends" | "regulations" | "map";
}

interface IPropsImage {
  text?: string | IInitiativeDescription[] | IRegulation[];
  image?: string;
  alt?: string;
  type?: "description" | "trends" | "regulations" | "map";
  src?: string;
}

const ImageWithFallback = ({src, alt, ...props}: IPropsImage) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setError(false);
    // setLoading(true);
  }, [src]);

  const handleError = () => {
    setError(true);
    setLoading(false);
  };

  const handleLoad = () => {
    setLoading(false);
  };
  console.log("loading", loading, "error", error, "src", src);
  return (
    <div
      style={{
        float: "left",
        borderRadius: "10px",
        marginRight: "10px",
        width: "153px",
        height: "114px",
        position: "relative",
        backgroundColor: "#1d2133",
      }}
    >
      {loading && !error && <LoaderSkeleton width="100%" height="100%" />}
      <img
        src={src}
        alt={alt}
        width={153}
        height={114}
        {...props}
        onError={handleError}
        onLoad={handleLoad}
        style={error || loading ? {display: "none"} : {borderRadius: "16px"}}
      />
      {error && (
        <img src={ImgMock} alt="заглушка" width={153} height={114} {...props} />
      )}
    </div>
  );
};

const isRichTextArray = (content: any): boolean => {
  if (!Array.isArray(content) || content.length === 0) return false;
  const first = content[0];
  return first && typeof first === "object" && "type" in first && "children" in first;
};

const getRichTextContent = (text: any, type?: string) => {
  if (type === "regulations" && Array.isArray(text)) {
    const regulations = text as IRegulation[];
    return regulations.flatMap((reg) => reg.content || []);
  }
  return text;
};

export const BlockDescription: FC<IProps> = ({text, image, type}) => {
  const [expanded, setExpanded] = useState(false);

  const richTextContent = getRichTextContent(text, type);
  const useRichText = isRichTextArray(richTextContent);

  let fullText = "";
  if (typeof text === "string") {
    fullText = text;
  } else if (
    (type === "description" || type === "trends" || type === "map") &&
    Array.isArray(text)
  ) {
    fullText = (text as IInitiativeDescription[])
      .flatMap(
        (description) => description.children?.map((child) => child.text) ?? []
      )
      .join("\n");
  } else if (type === "regulations" && Array.isArray(text)) {
    fullText = (text as IRegulation[])
      .flatMap(
        (regulation) =>
          regulation.content?.flatMap(
            (children) => children.children?.map((child) => child.text) ?? []
          ) ?? []
      )
      .join("\n");
  }

  const getLimitedWords = (input: string, maxWords: number) => {
    const words = input.split(/\s+/).filter(Boolean);
    if (words.length <= maxWords) return input;
    return words.slice(0, maxWords).join(" ");
  };

  const plainTextForCount = useRichText ? richTextToPlainText(richTextContent) : fullText;
  const isLimited = plainTextForCount.split(/\s+/).filter(Boolean).length > 25;
  const limitedText = getLimitedWords(fullText, 25);

  return (
    <div style={{color: "#ffffff"}}>
      {image && <ImageWithFallback src={image} alt="FlagRuIcon" />}
      {/* {image && <img src={image} alt="FlagRuIcon" width="55" height="55" />} */}
      <div>
        {useRichText ? (
          <div
            style={{
              maxHeight: expanded ? "none" : "100px",
              overflow: "hidden",
            }}
          >
            <RichTextParser content={richTextContent} />
          </div>
        ) : (
          <>
            {!expanded ? (
              <Markdown
                components={{
                  p: ({children}) => (
                    <p style={{marginBottom: "2px"}}>
                      {children}
                      {isLimited && <span style={{color: "#aaa"}}> ...</span>}
                    </p>
                  ),
                }}
              >
                {limitedText}
              </Markdown>
            ) : (
              <Markdown>{fullText}</Markdown>
            )}
          </>
        )}
        {isLimited && (
          <button
            style={{
              marginTop: 0,
              background: "none",
              border: "none",
              color: "#71c6fa",
              cursor: "pointer",
              fontSize: 14,
              padding: 0,
            }}
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? "Показать меньше" : "Показать больше"}
          </button>
        )}
      </div>
    </div>
  );
};
